var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconosubir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17.89 23.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_9-2);\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_9);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    "data-name": "Degradado sin nombre 9",
    x1: 0,
    y1: 17.05,
    x2: 17.89,
    y2: 17.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cd882d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cd882d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e1b45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#edcf75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f2da80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ba8432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-2",
    "data-name": "Degradado sin nombre 9",
    x1: 4.54,
    y1: 9.25,
    x2: 13.37,
    y2: 9.25,
    xlinkHref: "#Degradado_sin_nombre_9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.94,10.47c-.52.02-.89.57-.89,1.27v9.19s-14.18,0-14.18,0v-9.3c0-.65-.44-1.13-.88-1.15-.49-.02-.88.42-.98,1.03v10.04c.05.25.18.58.2.84.04.48.07.88.41,1.12.29.2.64.19.91-.17h14.82c.83,0,1.54-.86,1.54-1.96v-9.74c0-.7-.48-1.18-.95-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.04,17.45V4.14s-.69.87-.69.87l-1.17,1.53c-.37.49-.91.6-1.32.15-.37-.4-.47-1.23-.09-1.71L8.34.32c.31-.4.89-.44,1.21-.02l3.57,4.64c.38.49.32,1.29-.05,1.72-.4.47-.97.38-1.35-.12l-1.84-2.4v13.22c0,.64-.43,1.09-.87,1.13-.4.04-.97-.37-.97-1.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconosubir);
export default __webpack_public_path__ + "static/media/icono subir.b1797e77dcfb4d8d0acd20336c38d91b.svg";
export { ForwardRef as ReactComponent };